import styled from 'styled-components';

export default styled.h3`
  color: ${({ theme }) => theme.brand.title};
  margin-top: 0;
  margin-bottom: 15px;
`;
